import { SnackbarEvents } from "@gtmhub/shared/components/ui/snackbar/snackbar.events";
import { StateService } from "@uirouter/angularjs";
import { IModalScope } from "angular-ui-bootstrap";
import { UserProfileService } from "../profileService";
import { IProfile } from "@webapp/users/models/users.models";
import { UIErrorHandlingService } from "@gtmhub/error-handling";
import { IPatchedUser } from "../../models";
import { UserService } from "../../userService";
import { getCurrentUserId } from "../../current-user-storage";
import { CurrentUserPictureService } from "../../current-user-picture-service";

export interface IAvatarScope extends IModalScope {
  indicators: {
    loading?: boolean;
    uploading?: boolean;
  };
  picFile?: Blob;
  profile: IProfile;
  croppedDataUrl?: string;
  uploadedFileUrl?: string;
  upload(): void;
  remove(): void;
  restore(): void;
}

export class AvatarCtrl {
  private snackbarEvents: SnackbarEvents;
  public static $inject = ["$scope", "$state", "CurrentUserPictureService", "UserProfileService", "UserService", "UIErrorHandlingService"];

  constructor(
    private $scope: IAvatarScope,
    private $state: StateService,
    private currentUserPictureService: CurrentUserPictureService,
    private profileService: UserProfileService,
    private userService: UserService,
    private uiErrorHandlingService: UIErrorHandlingService
  ) {
    this.snackbarEvents = new SnackbarEvents($scope);
    this.$scope.upload = this.upload;
    this.$scope.remove = this.remove;
    this.$scope.restore = this.restore;
    this.$scope.indicators = {};
    this.$scope.profile = this.profileService.getProfile();
  }

  private restore = () => {
    const patchedUser: IPatchedUser = {
      restoreUserPicture: true,
    };

    this.$scope.indicators.uploading = true;

    this.userService
      .patchUser(getCurrentUserId(), patchedUser)
      .then(() => {
        this.userService.getUser(getCurrentUserId()).then((user) => {
          this.$scope.indicators.uploading = false;
          const profile = this.profileService.getProfile();
          profile.picture = user.picture;
          profile.pictureInfo.isPictureEdited = user.pictureInfo.isPictureEdited;
          this.profileService.userProfileUpdated(profile);
          this.$state.go("gtmhub.userProfile");
          this.snackbarEvents.broadcastShowSnackbar("avatar_updated");
        });
      })
      .catch((err) => {
        this.$scope.indicators.uploading = false;
        this.uiErrorHandlingService.handleModal(err);
      });
  };

  private remove = () => {
    this.$scope.picFile = null;
    this.$scope.croppedDataUrl = "";
  };

  private upload = () => {
    if (!this.$scope.croppedDataUrl) {
      return;
    }

    this.$scope.indicators.uploading = true;

    this.currentUserPictureService.updatePicture(this.$scope.croppedDataUrl).then(
      (url) => {
        this.$scope.indicators.uploading = false;
        this.$scope.uploadedFileUrl = url;
        this.$state.go("gtmhub.userProfile");
        this.snackbarEvents.broadcastShowSnackbar("avatar_updated");
      },
      (err) => {
        this.$scope.indicators.uploading = false;
        this.uiErrorHandlingService.handleModal(err);
      }
    );
  };
}
